import { gatewayApi as api } from './gatewayApi';
import { PartSecAttribute } from './partSecAttributesApi';

export interface PartTercAttribute {
  Id?: number;
  PartSecAttributeId: number;
  PartSecAttribute?: Pick<PartSecAttribute, 'Id' | 'Name'>;
  Name: string;
  Description?: string;
  Active: boolean;
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface PartTercAttributeListResponse {
  data: PartTercAttribute[];
  total: number;
}

export interface PartTercAttributeSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const partTercAttributesApi = {
  getAll: (params?: PartTercAttributeSearchParams): Promise<PartTercAttributeListResponse> =>
    api.get('/parttercattributes', params),

  getById: (id: number): Promise<PartTercAttribute> =>
    api.get(`/parttercattributes/${id}`),

  create: (item: Omit<PartTercAttribute, 'Id'>): Promise<PartTercAttribute> =>
    api.post('/parttercattributes', item),

  update: (id: number, item: Partial<PartTercAttribute>): Promise<PartTercAttribute> =>
    api.put(`/parttercattributes/${id}`, item),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/parttercattributes/${id}`),

  search: (params: PartTercAttributeSearchParams): Promise<PartTercAttributeListResponse> =>
    api.post('/parttercattributes/search', params),

  bulkActivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/parttercattributes/bulk-activate', { ids }),

  bulkDeactivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/parttercattributes/bulk-deactivate', { ids }),

  bulkDelete: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.post('/parttercattributes/bulk-delete', { ids }),

  getStatistics: (): Promise<{ total: number; active: number; inactive: number }> =>
    api.get('/parttercattributes/statistics'),

  exportToCSV: (params?: PartTercAttributeSearchParams): Promise<Blob> =>
    api.getBlob('/parttercattributes/export', { params }),

  validation: {
    validate: (item: Partial<PartTercAttribute>): string[] => {
      const errors: string[] = [];
      if (!item.PartSecAttributeId && (item.PartSecAttributeId as any) !== 0) errors.push('Part Secondary Attribute is required');
      if (!item.Name || item.Name.trim().length === 0) errors.push('Name is required');
      else if (item.Name.trim().length < 2) errors.push('Name must be at least 2 characters');
      else if (item.Name.trim().length > 100) errors.push('Name must be less than 100 characters');
      if (item.Description && item.Description.length > 500) errors.push('Description must be less than 500 characters');
      if (item.Active === undefined || item.Active === null) errors.push('Active status is required');
      return errors;
    },
    validateBulk: (ids: number[]): string[] => {
      const errors: string[] = [];
      if (!ids || ids.length === 0) errors.push('Select at least one item');
      if (ids.length > 100) errors.push('Too many selected items');
      return errors;
    },
  },
};

export default partTercAttributesApi; 